/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";

import Grn from "layouts/grn-details/GRNSTV1W/grn";
import GrnW1 from "layouts/grn-details/GRNSTV1W1/grn";
import GrnW2 from "layouts/grn-details/GRNSTV1W2/grn";
import GrnW3 from "layouts/grn-details/GRNSTV1W3/grn";
import GrnW4 from "layouts/grn-details/GRNSTV1W4/grn";
import GroupedGrn from "layouts/grn-details/GRNSTV3W/grouped-grn";
import Cookies from "universal-cookie";
import GrnNotPrinted from "./GRNSTV2W/grn-not-printed";
import GrnNotPrintedW1 from "./GRNSTV2W1/grn-not-printed";

const cookies = new Cookies();

const GrnDetails = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let GRNSTV1WAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "f8c10f40-97fe-43fa-bdbc-6e00e40259a0",
  );

  let GRNSTV2WAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "a9b2d52b-e930-48e0-bdf3-af76bee63a23",
  );

  let GRNSTV3WAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "7df3b669-fca6-4ffa-a989-b0850830b8c9",
  );

  let GRNSTV1W1Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "42ce5388-8c94-48b3-b422-6fe681a5787c",
  );

  let GRNSTV1W2Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "72d6c25e-2b3c-43b6-94a2-cd09820488de",
  );

  let GRNSTV1W3Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "1b04f86b-e9cd-475b-ad13-6d4e4ea5b322",
  );
  let GRNSTV1W4Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "123afa58-720d-43c9-ab7c-c8a4f620e89a",
  );

  let GRNSTV2W1Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "99a2faed-168e-4992-b007-bb76185308a1",
  );

  // Helper to render the correct GRN component based on access
  const getGrnComponent = () => {
    if (GRNSTV1W1Access) return <GrnW1 />;
    if (GRNSTV1W2Access) return <GrnW2 />;
    if (GRNSTV1W3Access) return <GrnW3 />;
    if (GRNSTV1W4Access) return <GrnW4 />;
    if (GRNSTV1WAccess) return <Grn />;
    return null;
  };

  // Helper to render the correct Printed GRN component based on access
  const getPrintedGrnComponent = () => {
    if (GRNSTV2W1Access) return <GrnNotPrintedW1 />;
    if (GRNSTV2WAccess) return <GrnNotPrinted />;
    return null;
  };

  // Build tabs dynamically based on access
  const tabs = [];

  // GRN Details tab
  if (
    GRNSTV1WAccess ||
    GRNSTV1W1Access ||
    GRNSTV1W2Access ||
    GRNSTV1W3Access ||
    GRNSTV1W4Access
  ) {
    tabs.push({
      header: "GRN Details",
      content: getGrnComponent(),
    });
  }

  // Grouped GRN tab
  if (GRNSTV3WAccess) {
    tabs.push({
      header: "Grouped GRN",
      content: <GroupedGrn />,
    });
  }

  // Printed GRN tab
  if (GRNSTV2WAccess || GRNSTV2W1Access) {
    tabs.push({
      header: "Printed GRN",
      content: getPrintedGrnComponent(),
    });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {tabs.length > 0 ? (
              <TabView>
                {tabs.map((tab, idx) => (
                  <TabPanel key={idx} header={tab.header}>
                    {tab.content}
                  </TabPanel>
                ))}
              </TabView>
            ) : (
              <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                No Grn Access
              </h4>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(GrnDetails);
